import React, { useState, useContext, useEffect, useReducer } from 'react';
import ImgRed from '../../images/red-bullet.gif';
import ImgOrange from '../../images/orange-bullet.gif';
import ImgGreen from '../../images/green-bullet.gif';

const AlertInstructions = (props) => {

    return (
        <div>
            <div className="container-fluid">
                <h4>How to configure your notifications</h4>

                <div className="col-12">
                    <b>Service type:</b> you should set up notification services for each of your selected communication channelsmedia devices: email or SMS.<br />

                    <b>Disaster type:</b> select the disaster type. GDACS sends notifications for Earthquakes and Tropical Cyclones only, please note that earthquakes will automatically include tsunamis.<br />

                    <b>Region:</b> if you select one or more regions, you will only receive notifications for events in that regions. If you register for worldwide alerts do not specify any other region.<br />
                </div>
                <img id="gdacs_logo_image" src="images/GDACS_Alerts_Regions.png" className="d-flex justify-content-center col-lg-7" />
                <div className="col-12">
                    <b>GDACS level:</b> GDACS evaluates the impact of natural hazards in three levels:<br />
                    <ul style={{paddingLeft: "25px"}}>
                        <li><img src={ImgRed} /> - Red: most likely a catastrophic event, requiring international assistance</li>
                        <li><img src={ImgOrange} />  - Orange: can be a disaster requiring international assistance</li>
                        <li><img src={ImgGreen} />  - Green: unlikely to be a disaster requiring international assistance, although it can be a local disaster</li>
                    </ul>

                    If you register for Green notifications, you will also receive Orange and Red notifications. Orange will include both Orange and Red events.<br />

                    <b>Language:</b> select the language for your notifications. Note that options vary depending on the service<br />

                    <b>Night option</b>: it is possible to queue notifications sent at night (in your time zone set in the previous step) until 06:00 the following day.<br />
                </div>
            </div>
        </div>
    )
}

export { AlertInstructions };